<template>
	<div class="section pride-people-container">
		<div class="pride-inner">
			<pride-place-card v-for="(place, index) in places" :key="index" :index="index" :place="place"/>
		</div>
	</div>
</template>

<script>

  import PridePlaceCard from "@/components/pride/PridePlaceCard";

	export default {
		name: "pride-places-container",
		props: {
			places: {
				type: Array
			}
		},
    components: {
      PridePlaceCard,
    },
		mounted() {
      this.changeBG();
    },
		methods: {

      changeBG(){   

        let container = document.querySelector('.pride-people-container');
        let colors = ['#ec1c24', '#ed2f25', '#fae72b', '#dadf2d','#16b036','#3e62b0', '#6d459b']

        window.addEventListener('scroll', () => {
					if (document.documentElement.scrollTop || window.pageYOffset > window.innerHeight) {
						// var diff = parseInt(window.pageYOffset - window.innerHeight);
						var startPoint = parseInt(window.pageYOffset - container.offsetTop);
						var step = parseInt(container.offsetHeight / 9);
						container.style.backgroundColor = colors[Math.floor(startPoint / step)];
					}
				})
      }
    },
	};

</script>
<style lang='scss' scoped>
	.pride-people-container {
		transition: 0.8s all;
		display: flex;
		justify-content: center;
		flex-direction: column;
		background-color: #ec1c24;

		.pride-inner {
			padding: 2em 0;
		}
	}


</style>


// WEBPACK FOOTER //
// src/components/pride/PridePlacesContainer.vue